import type { RuleKind } from "~/lib/api/types";

/**
 * Filter facets.
 *
 * These are stable domain vocabularies (Brazilian jurisdictions, UF codes, the
 * tax tag taxonomy, rule kinds) rather than data, so the console ships them
 * instead of paying a round trip to populate every filter bar. When the API
 * grows a `/v1/facets` endpoint these become its fallback, not its duplicate.
 */
export const JURISDICTIONS = [
  "BR-Federal",
  "BR-SP",
  "BR-RJ",
  "BR-MG",
  "BR-RS",
  "BR-PR",
  "BR-SC",
  "BR-BA",
  "BR-PE",
  "BR-GO",
] as const;

export const UFS = [
  "AC",
  "AL",
  "AM",
  "AP",
  "BA",
  "CE",
  "DF",
  "ES",
  "GO",
  "MA",
  "MG",
  "MS",
  "MT",
  "PA",
  "PB",
  "PE",
  "PI",
  "PR",
  "RJ",
  "RN",
  "RO",
  "RR",
  "RS",
  "SC",
  "SE",
  "SP",
  "TO",
] as const;

export const TAX_TAGS = [
  "icms-st",
  "mva",
  "ncm",
  "cest",
  "ipi",
  "difal",
  "substituicao-tributaria",
  "convenio",
  "protocolo",
  "aliquota-interna",
  "beneficio-fiscal",
  "reforma-tributaria",
] as const;

export const RULE_KINDS: readonly RuleKind[] = ["FISCAL", "OPERATIONAL_COST", "COMMERCIAL_FEE"];

export const AUDIT_ACTIONS = [
  "EVIDENCE_APPROVED",
  "EVIDENCE_REJECTED",
  "EVIDENCE_BULK_REVIEWED",
  "PROPOSAL_CREATED",
  "PROPOSAL_APPROVED",
  "PROPOSAL_REJECTED",
  "RULESET_PUBLISHED",
  "RULESET_ROLLED_BACK",
  "SOURCE_RUN_TRIGGERED",
  "SOURCE_PAUSED",
  "DLQ_REPLAYED",
  "CALCULATION_EXPORTED",
] as const;
